import SEO from "@/components/SEO";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function QuoteSuccess() {
  return (
    <>
      <SEO title="Quote submitted — Tech Alpha SSL" description="Your quote request has been received." canonical="https://techalphassl.com/quote-success" />
      <section className="pt-24 pb-24">
        <div className="container-page max-w-2xl text-center">
          <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-[#1565FF]/10 text-[#1565FF] dark:bg-white/5 dark:text-[#4FC3F7]">
            <CheckCircle2 className="h-8 w-8" />
          </div>
          <h1 className="mt-6 text-3xl md:text-5xl font-semibold tracking-tighter">Quote received — thank you.</h1>
          <p className="mt-4 text-muted-foreground">A senior engineer will review your requirements and reach out within one business day.</p>
          <div className="mt-8 flex justify-center gap-3">
            <Link to="/" className="btn-primary" data-testid="qs-home">Back to home</Link>
            <Link to="/services" className="btn-ghost" data-testid="qs-services">Explore services</Link>
          </div>
        </div>
      </section>
    </>
  );
}
